import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('cuaratech_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith('/verify') && !path.startsWith('/login') && !path.startsWith('/register')) {
        localStorage.removeItem('cuaratech_token');
        localStorage.removeItem('cuaratech_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(e);
  }
);

export const fmtMoney = (n, currency = 'USD') => {
  const v = Number(n || 0);
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(v);
};

// All dates displayed in Caracas/Venezuela timezone.
const APP_TZ = 'America/Caracas';

export const fmtDate = (d) => {
  if (!d) return '';
  try {
    return new Date(d).toLocaleDateString('es-VE', {
      year: 'numeric', month: '2-digit', day: '2-digit', timeZone: APP_TZ,
    });
  } catch { return ''; }
};

export const fmtDateTime = (d) => {
  if (!d) return '';
  try {
    return new Date(d).toLocaleString('es-VE', {
      dateStyle: 'medium', timeStyle: 'short', timeZone: APP_TZ,
    });
  } catch { return ''; }
};

export const LEGAL_FOOTER =
  'Precios expresados en USD pero pagaderos a la tasa BCV del día de pago. Si el pago es en divisas debe agregarse el IGTF pertinente.';
